import { NotificationActionTypes, NotificationAction, NotificationType } from '../actions/NotificationsActions';

export interface NotificationState {
    notification: {
        show: boolean,
        message: string,
        notificationType: NotificationType
    }
}

const INITIAL_STATE: NotificationState = {
    notification: {
        show: false,
        message: "",
        notificationType: NotificationType.Success,
    }
};

export default function(state = INITIAL_STATE, action: NotificationAction): NotificationState {
    switch(action.type) {
        case NotificationActionTypes.ADD_NOTIFICATION:
            return {
                ...state,
                notification: {
                    show: true,
                    notificationType: action.notificationType,
                    message: action.payload
                }
            };
        case NotificationActionTypes.HIDE_NOTIFICATION:
            return {
                ...state,
                notification: {
                    show: false,
                    notificationType: state.notification.notificationType,
                    message: ''
                }
            };
        default:
            return state;
    }
}